import React from 'react';
import $image_url from 'js/utils/image_url';
import routes from 'js/core_pre_webpack/routes';
import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';
import styled from 'astroturf/react';
import { keptAlivePost } from 'js/utils/kept_alive_post';
import Modal from 'js/components/modals/Modal';
import _AnchorContainer from "WinBackPing-AnchorContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=AnchorContainer";
import _Anchor from "WinBackPing-Anchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=Anchor";
import _Takeover from "WinBackPing-Takeover.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=Takeover";
import _TakeoverImage from "WinBackPing-TakeoverImage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=TakeoverImage";
import _CtaRow from "WinBackPing-CtaRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=CtaRow";
import _NoThanksButton from "WinBackPing-NoThanksButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/WinBackPing.tsx?styleId=NoThanksButton";


const AnchorContainer = /*#__PURE__*/styled("div", null, {
  displayName: "AnchorContainer",
  styles: _AnchorContainer
});

const Anchor = /*#__PURE__*/styled("a", null, {
  displayName: "Anchor",
  styles: _Anchor
});

const Takeover = /*#__PURE__*/styled("div", null, {
  displayName: "Takeover",
  styles: _Takeover
});

const TakeoverImage = /*#__PURE__*/styled("img", null, {
  displayName: "TakeoverImage",
  styles: _TakeoverImage
});

const CtaRow = /*#__PURE__*/styled("div", null, {
  displayName: "CtaRow",
  styles: _CtaRow
});

const NoThanksButton = /*#__PURE__*/styled("button", null, {
  displayName: "NoThanksButton",
  styles: _NoThanksButton
});

interface Props extends OnsitePingProps {
  couponCode: string;
}

type State = {
  open: boolean;
};

export default class WinBackPing extends OnsitePing<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  render() {
    if (this.state.open) {
      return this.renderTakeoverPing();
    } else {
      return null;
    }
  }

  renderTakeoverPing() {
    return (
      <Modal onClose={() => this.dismissPing()}>
        <Takeover>
          <TakeoverImage
            src={$image_url('page_50_percent.svg')}
            alt="50% off Academia Premium"
          />
          <h1>Reactivate Your Membership & Get 50% Off</h1>
          <p>{this.getBody()}</p>
          <CtaRow>
            {this.renderButton()}
            <NoThanksButton onClick={() => this.dismissPing()}>
              No Thanks
            </NoThanksButton>
          </CtaRow>
        </Takeover>
      </Modal>
    );
  }

  getBody() {
    return 'Reactivate now and get the tools you need to accelerate your research and advance your career.';
  }

  renderButton() {
    return (
      <AnchorContainer>
        <Anchor
          href={this.getUpgradeURL()}
          onClick={() => this.recordClickthrough()}
        >
          {this.getButtonText()}
        </Anchor>
      </AnchorContainer>
    );
  }

  recordClickthrough(): void {
    const url = routes.record_ping_clickthrough_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  dismissPing(): void {
    this.setState({ open: false });
    this.recordDismissal();
  }

  recordDismissal(): void {
    const url = routes.record_ping_dismissal_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    });
    keptAlivePost(url, {
      processData: false,
      data: { ping_name: this.props.pingName },
    });
  }

  getUpgradeURL() {
    return routes.checkout_url({
      trigger: 'win-back-ping',
      premium_discount_coupon: this.props.couponCode,
    });
  }

  getButtonText() {
    return 'Reactivate and Get 50% Off ▸';
  }
}
